import { Observable } from "rxjs/Observable";
import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import { UserService } from "../../user/user.service";

@Injectable()
export class AccessTerminalService {
  private node = "Access Terminal Personnel";

  constructor(private db: AngularFireDatabase, private userService: UserService) {}

  async create(user, community): Promise<any> {
    const userExists = await this.doesUserExistAsAccessTerminalPersonnel(community.id, user.id);
    if (userExists) {
      return { state: false, message: "User already exists as an Access Terminal Personnel. Verify user\"s email" };
    } else {
      delete user.isAdmin;
      delete user.isSuper;
      Promise.all([
        this.db.list(`/profile`).update(user.id, user),
        this.db.list(`/profile/${user.id}/communities`).update(community.id, { id: community.id, name: community.name }),
        this.db
          .list(`/profile/${user.id}/communities/${community.id}`)
          .update("roles", { "Access Terminal Personnel": true }),
        this.db.list(`/community_resources/${community.id}/Access Terminal Personnel`).set(user.id, true),
        this.db.list(`/community_users/${community.id}`).set(user.id, true)
      ]).then();

      return { state: true, message: "User successfully added." };
    }
  }

  private async doesUserExistAsAccessTerminalPersonnel(communityId, userId): Promise<any> {
    return new Promise<any>(resolve => {
      this.db
        .object(`/community_resources/${communityId}/Access Terminal Personnel/${userId}`)
        .valueChanges()
        .subscribe(data => resolve(data));
    });
  }

  list(communityId): any {
    return this.db
      .object(`/community_resources/${communityId}/${this.node}`)
      .valueChanges()
      .map(data => {
        const accessTerminalIds = data ? Object.keys(data) : [];

        return accessTerminalIds.map(id => {
          const $accessTerminalProfile = this.db.object(`/profile/${id}`).valueChanges();

          return Observable.zip($accessTerminalProfile, (profile: any) => {
            if (profile == null) {
              return;
            }
            profile.name = `${profile.firstName} ${profile.lastName}`;

            // add properties to profile object to be used to check if AT is active or not
            if (profile.communities && profile.communities[communityId]) {
              profile["hasRoles"] = profile.communities[communityId].roles != null;
              profile["isActiveAT"] =
                profile.communities[communityId].roles != null &&
                profile.communities[communityId].roles["Access Terminal Personnel"] != null;
            }

            return profile;
          });
        });
      })
      .flatMap(user => {
        return user.length ? Observable.combineLatest(user) : Observable.of([]);
      });
  }

  update(user, community): any {
    user.updatedAt = Date.now();
    delete user.isAdmin;
    delete user.isSuper;
    this.db.list(`/profile`).update(user.id, user)
    .then(() => {
      this.db.list(`/profile/${user.id}/communities`).update(community.id, { id: community.id, name: community.name });
    }).catch(err => {
      console.log(err);
    });

    return { state: true, message: "User successfully updated." };
  }

  delete(communityId, userId): any {
    this.db.list(`/community_resources/${communityId}/${this.node}`).remove();
    this.db.list(`/profile/${userId}`).remove();
  }

  deactivate(communityId, accessTermId): any {
    this.userService.updateUserRoleStatus(accessTermId, "Access Terminal Personnel", false, communityId);
  }

  activate(communityId, accessTermId): any {
    this.userService.updateUserRoleStatus(accessTermId, "Access Terminal Personnel", true, communityId);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/user/access-terminal.service.ts